
import React from 'react';
// images
import highResDesktopImageWebp from './images/term-life-insurance-hero.webp';
import highResMobileImageWebp from './images/term-life-insurance-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='term-life-insurance-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Term Life Insurance'
      headingText='Protection on your terms.'
      descriptionText={<>It&#39;s one of the most affordable types of life insurance designed to protect your loved ones for a set amount of time. Find out how much coverage you&#39;ll need.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='a smiling father gives his laughing daughter a piggyback ride while walking through a grassy field on a sunny day'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
